import type { Selection } from '@getaccept/editor-lib';
import { Context } from '@getaccept/editor-lib';

export const getIsContextViewAndIsOnlyChild = (
  context: Context,
  isSelectedNodeLastInSection: boolean
): boolean => context === Context.DocumentView && isSelectedNodeLastInSection;

export const getIsContextDsrAndLastNodeInLastSection = (
  context: Context,
  isSelectedNodeLastInSection: boolean,
  isLastSection: boolean
) => Context.DsrEdit === context && isSelectedNodeLastInSection && isLastSection;

export const toLowerCase = (text: string): string => String(text).toLowerCase();

export const handleSelectNode = (
  selected: Selection,
  payload: Partial<Selection> = {}
): Partial<Selection> => ({
  sectionId: selected.sectionId,
  rowId: selected.rowId,
  cellId: selected.cellId,
  nodeId: selected.nodeId,
  ...payload,
});
